var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"userSettingsToken"}},[_c('tokens',{attrs:{"scope":"user","write-permission":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }